import { render, staticRenderFns } from "./EmergencyContactDetailsForm.vue?vue&type=template&id=5674f936&scoped=true&"
import script from "./EmergencyContactDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./EmergencyContactDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./EmergencyContactDetailsForm.vue?vue&type=style&index=0&id=5674f936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5674f936",
  null
  
)

export default component.exports